require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./separator"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./separator"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./separator")) : factory(root["./utils"], root["./svgicon"], root["./separator"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__45__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[69],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__45__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(565);


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Toolbar = _interopRequireDefault(__webpack_require__(566));

exports["default"] = _Toolbar["default"];
exports.Toolbar = _Toolbar["default"];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _separator = _interopRequireDefault(__webpack_require__(45));

var _svgicon = __webpack_require__(13);

var _baUiCarbon = __webpack_require__(12);

var _crop_ = _interopRequireDefault(__webpack_require__(567));

var _edit_ = _interopRequireDefault(__webpack_require__(568));

var _image_ = _interopRequireDefault(__webpack_require__(569));

var _refined_ = _interopRequireDefault(__webpack_require__(570));

var _filter_ = _interopRequireDefault(__webpack_require__(571));

var _videoFile_ = _interopRequireDefault(__webpack_require__(572));

var _settingsAdjust_ = _interopRequireDefault(__webpack_require__(73));

var _redo_ = _interopRequireDefault(__webpack_require__(573));

var _textCreation_ = _interopRequireDefault(__webpack_require__(574));

var _undo_ = _interopRequireDefault(__webpack_require__(575));

var _webpage_ = _interopRequireDefault(__webpack_require__(576));

__webpack_require__(577);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var cogButtons = {
  crop: {
    icon: _crop_["default"],
    desc: 'Crop'
  },
  editPreview: {
    icon: _edit_["default"],
    desc: 'Edit or preview'
  },
  fields: {
    icon: _refined_["default"],
    desc: 'Fields'
  },
  filters: {
    icon: _filter_["default"],
    desc: 'Filters'
  },
  image: {
    icon: _image_["default"],
    desc: 'Image'
  },
  media: {
    icon: _videoFile_["default"],
    desc: 'Media'
  },
  properties: {
    icon: _settingsAdjust_["default"],
    desc: 'Properties'
  },
  redo: {
    icon: _redo_["default"],
    desc: 'Redo'
  },
  text: {
    icon: _textCreation_["default"],
    desc: 'Text'
  },
  undo: {
    icon: _undo_["default"],
    desc: 'Undo'
  },
  webPage: {
    icon: _webpage_["default"],
    desc: 'WebPage'
  }
};
var BaPropTypes = _utils.propsUtils.BaPropTypes; // Toolbar.Spacer layout helper: deprecated Carbon pattern does not include spacers in toolbars

var Spacer = function Spacer(props) {
  return null;
};

Spacer.propTypes = {
  size: BaPropTypes.deprecated('deprecated - Carbon pattern does not include spacers (If you really want a spacer you can add it as a toolbar item).')
}; // Toolbar.Separator layout helper: render a vertical separator bar (size prop is no longer supported)

var VSeparator = function VSeparator(_ref) {
  var size = _ref.size,
      passThrough = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["size"]);
  return /*#__PURE__*/_react["default"].createElement(_separator["default"], (0, _extends2["default"])({
    "data-tid": "ba-common-toolbar__v-separator",
    orientation: "vertical",
    hMargin: 0
  }, passThrough));
};

VSeparator.propTypes = {
  /**  BaPropTypes.deprecated('deprecated - Carbon only supports a thin line. All separtors will be mapped to a thin line.'), */
  size: BaPropTypes.deprecated('deprecated - Carbon only supports a thin line. All separtors will be mapped to a thin line.')
}; // Toolbar.Button item helper: renders a button

var Button = function Button(props) {
  var cogType = props.cogType,
      _props$kind = props.kind,
      _kind = _props$kind === void 0 ? 'ghost' : _props$kind,
      buttonProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["cogType", "kind"]);

  var _children = props.children,
      _hasIconOnly = props.hasIconOnly,
      _iconDescription = props.iconDescription,
      _renderIcon = props.renderIcon,
      _title = props.title;

  if (cogType) {
    var _children2, _iconDescription2, _renderIcon2, _title2;

    _children = (_children2 = _children) != null ? _children2 : cogButtons[cogType].desc;
    _iconDescription = (_iconDescription2 = _iconDescription) != null ? _iconDescription2 : cogButtons[cogType].desc;
    _renderIcon = (_renderIcon2 = _renderIcon) != null ? _renderIcon2 : function (props) {
      return (0, _svgicon.createIcon)(cogButtons[cogType].icon.id, 'small', null, null, props);
    };
    _title = (_title2 = _title) != null ? _title2 : cogButtons[cogType].desc;
  }

  if (!_renderIcon) {
    var _title3;

    _iconDescription = undefined;
    _hasIconOnly = undefined;
    _title = (_title3 = _title) != null ? _title3 : _children;
  } else if (_hasIconOnly) {
    var _iconDescription3;

    _iconDescription = (_iconDescription3 = _iconDescription) != null ? _iconDescription3 : _children;
    _title = undefined;
    _children = undefined;
  } else {
    var _title4;

    _iconDescription = undefined;
    _title = (_title4 = _title) != null ? _title4 : _children;
  }

  return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Button, (0, _extends2["default"])({}, buttonProps, {
    hasIconOnly: _hasIconOnly,
    iconDescription: _iconDescription,
    kind: _kind,
    renderIcon: _renderIcon,
    title: _title
  }), _children);
};

Button.propTypes = {
  /** The label for the button */
  children: _propTypes["default"].node,

  /** A cognos predefined button type */
  cogType: _propTypes["default"].oneOf(Object.keys(cogButtons)),

  /** Indictates it is an icon only button */
  hasIconOnly: _propTypes["default"].bool,

  /** icon tooltip */
  iconDescription: _propTypes["default"].string,

  /** onClick callback function */
  onClick: _propTypes["default"].func.isRequired,

  /** icon to render */
  renderIcon: _propTypes["default"].node
};
VSeparator.isSeparator = true;

var Toolbar = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Toolbar, _Component);

  function Toolbar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_flexWrap", function () {
      var _this$props$flexWrap = _this.props.flexWrap,
          flexWrap = _this$props$flexWrap === void 0 ? 'wrap' : _this$props$flexWrap;
      var _this$props$breakpoin = _this.props.breakpoint,
          breakpoint = _this$props$breakpoin === void 0 ? flexWrap === 'wrap' ? 'md' : 'max' : _this$props$breakpoin; // TODO: the Toolbar responsiveness defined in the Carbon toolbar is complicated
      // and doesn't map to the standard html wrappings ('wrap', 'nowrap', 'wrap-reverse')

      if (breakpoint === 'max' || breakpoint === 'xlg') {
        // Displays all controls and functionality in one row
        // with the option to make the search field longer or shorter
        return 'nowrap';
      } else if (breakpoint === 'lg') {
        // The search field is truncated into a button
        // or use an overflow menu to display collapsed controls
        return 'nowrap';
      } else if (breakpoint === 'md') {
        // Compresses the full text toolbar into two rows
        return 'wrap';
      } else if (breakpoint === 'sm') {
        // A more compact version of “md” with collapsed controls in an overflow menu
        return 'wrap';
      }
    });
    return _this;
  }

  var _proto = Toolbar.prototype;

  _proto._isSeparator = function _isSeparator(component) {
    if (component && component.type && component.type.isSeparator) return true;
    return false;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        align = _this$props.align,
        border = _this$props.border,
        breakpoint = _this$props.breakpoint,
        children = _this$props.children,
        className = _this$props.className,
        orientation = _this$props.orientation,
        style = _this$props.style,
        variant = _this$props.variant,
        flexWrap = _this$props.flexWrap,
        gap = _this$props.gap,
        toolbarProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["align", "border", "breakpoint", "children", "className", "orientation", "style", "variant", "flexWrap", "gap"]);
    var classNames = (0, _utils.classnames)('ba-common-toolbar', align, variant, orientation, {
      border: border
    });
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, toolbarProps, {
      className: classNames + " " + className,
      style: (0, _extends2["default"])({
        flexWrap: this._flexWrap()
      }, style)
    }), _react["default"].Children.map(children, function (child, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "ba-common-toolbar__item " + (_this2._isSeparator(child) ? (0, _utils.classnames)('separator') : ''),
        key: i,
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
            if (child.props.onClick) child.props.onClick();
          }
        }
      }, child);
    }));
  };

  return Toolbar;
}(_react.Component);

exports["default"] = Toolbar;
(0, _defineProperty2["default"])(Toolbar, "propTypes", {
  /** Align the toolbar */
  align: _propTypes["default"].oneOf(['right', 'left', 'center']),

  /** Put a 1px solid boarder around the Toolbar */
  border: _propTypes["default"].bool,

  /** Define the breakpoints for the responsiveness of the Toolbar */
  breakpoint: _propTypes["default"].oneOf(['max', 'xlg', 'lg', 'md', 'sm']),

  /** Toolbar items */
  children: _propTypes["default"].node.isRequired,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** ?deprecated? - Specifies whether the toolbar will be drawn horizontally or vertically (Carbon does not have a vertical pattern) */
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /** Custom css styles applied to the toolbar wrapper */
  style: _propTypes["default"].object,

  /** Align options are disabled under inline mode. Only select align options when variant is frame */
  variant: _propTypes["default"].oneOf(['frame', 'inline']),

  /** deprecated - use Carbon prop breakpoint */
  flexWrap: BaPropTypes.deprecated('deprecated - use Carbon prop breakpoint'),

  /** deprecated - Carbon pattern does not support gap */
  gap: BaPropTypes.deprecated('deprecated - Carbon pattern does not support gap/spacer')
});
(0, _defineProperty2["default"])(Toolbar, "defaultProps", {
  align: 'left',
  border: false,
  breakpoint: undefined,
  children: undefined,
  className: '',
  orientation: 'horizontal',
  style: {},
  variant: 'inline',
  // deprecated
  flexWrap: undefined,
  gap: undefined
});
(0, _defineProperty2["default"])(Toolbar, "LeftItems", function (_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _utils.classnames)('itemLeft')
  }, children);
});
(0, _defineProperty2["default"])(Toolbar, "RightItems", function (_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _utils.classnames)('itemRight')
  }, children);
});
(0, _defineProperty2["default"])(Toolbar, "Spacer", Spacer);
(0, _defineProperty2["default"])(Toolbar, "Separator", VSeparator);
(0, _defineProperty2["default"])(Toolbar, "Button", Button);

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/crop_32");

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/edit_32");

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/image_32");

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/refined_16");

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/filter_32");

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/video-file_32");

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/redo_32");

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/text--creation_32");

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/undo_32");

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/webpage_32");

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(578);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-toolbar{position:relative;margin:0px;align-items:center}.ba-common-toolbar:focus{outline:2px solid #a8c0f3}.ba-common-toolbar.is-inline{display:inline-flex}.ba-common-toolbar.is-frame{display:flex}.ba-common-toolbar.is-vertical{display:inline-block}.ba-common-toolbar.is-border{border-width:1px;border-style:solid}.ba-common-toolbar.is-left{justify-content:flex-start}.ba-common-toolbar.is-right{justify-content:flex-end}.ba-common-toolbar .is-itemLeft{position:absolute;left:0;top:0}.ba-common-toolbar .is-itemRight{position:absolute;right:0;top:0}.ba-common-toolbar.is-center{justify-content:center}.ba-common-toolbar.is-center .ba-common-toolbar__item{margin-right:8px;margin-left:8px}.ba-common-toolbar__item{min-width:0}.ba-common-toolbar__item.is-separator{align-self:stretch}.ba-common-toolbar.is-border{border-color:#949394}\n", ""]);

// exports
exports.locals = {
	"toolbarClassName": "\"ba-common-toolbar\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/settings--adjust_32");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[564,0]]]);
});